import React from 'react';
import { _t } from 'utils';
import { getConfig } from 'utils/config';

export default () => {
  const config = getConfig();
  const { settings = {} } = config;
  const { support = {} } = settings;
  const {
    email = '', phone = '', emailSubject = '', emailBody = '',
  } = support;
  const mailBody = [`subject=${emailSubject}`, `body=${emailBody}`].join('&');

  return (
    <section className="screen-data-centers-help">
      <h3 className="cards-top-title">{_t('Need Help?')}</h3>
      <div className="fancy-cards">
        {/* <div style={{ background: '#0f9d58' }}>
          <h3>{_t('Online Help')}</h3>
          <p>{_t('Still got some question?')}</p>
          <span>
            <a href="https://dcd.ionos.com/help">{_t('Online Help')}</a>
          </span>
        </div>


        <div style={{ background: '#f50057' }}>
          <h3>{_t('DevOps Central Community')}</h3>
          <p>{_t('Our community for developers')}</p>
          <span>
            <a href="https://devops.ionos.com/">{_t('DevOps Community')}</a>
          </span>
        </div> */}

        <div className="fancy-cards-full">
          {/* <img src="https://dcd.ionos.com/latest/dcd/brandings/domains/ionos-common-assets/welcome/support-teammember.png" alt="..." /> */}
          <div>
            <h3>{_t('Your Free 24/7 support')}</h3>
            <p>{_t('Our support team is available around the clock')}</p>
            <span>
              {`${_t('Email')}: `}
              <a href={`mailto:${email}?${mailBody}`}>{email}</a>
              <br />
              {`${_t('Hotline')}: `}
              <a href={`tel:${phone}`}>{phone}</a>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};
